export const CLEAR_SUBSCRIPTION_PLANS = 'CLEAR_SUBSCRIPTION_PLANS';

export const clearSubscriptionPlans = () => ({
  type: CLEAR_SUBSCRIPTION_PLANS
});
